export const CLIENT_GOAL_MAX_LENGTH = 300;
export const ACTIONABLE_INTERVENTION_MAX_LENGTH = 2000;
export const COMMENTS_MAX_LENGTH = 2000;
